import React, { useState } from "react";
import PropTypes from "prop-types";
import { InfoPanel as InfoPanelComponent } from "../../sharedComponents/InfoPanel";
import { InfoGrid } from "./InfoGrid";
import { Profile } from "./Profile";
import { Row, Cell } from "../Grid/Grid";

const InfoPanel = ({ members }) => {
	const [activeKey, setActiveKey] = useState(null);

	return (
		<Row cols="4" className="relative">
			{members.map(member => (
				<Cell key={member.id}>
					<InfoPanelComponent isActive={member.id === activeKey}>
						<InfoPanelComponent.View>
							<Profile
								isActive={member.id === activeKey}
								name={member.profile?.name}
								role={member.profile?.role}
								image={member.profile.image}
								imageSrcSet={member.profile.imageSrcSet}
								id={member.id}
								setKey={id => {
									setActiveKey(id);
								}}
								activeMember={member.id === activeKey && member.id}
							/>
						</InfoPanelComponent.View>
						<InfoPanelComponent.Info>
							<InfoGrid details={member.details} footer={member.footer} />
						</InfoPanelComponent.Info>
					</InfoPanelComponent>
				</Cell>
			))}
		</Row>
	);
};
InfoPanel.propTypes = {
	members: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string,
			profile: PropTypes.shape({
				name: PropTypes.string.isRequired,
				role: PropTypes.string.isRequired,
				isActive: PropTypes.string,
				image: PropTypes.shape({
					alt: PropTypes.string,
					cloudinary: PropTypes.shape({
						adoptHeight: PropTypes.bool,
						aspectRatio: PropTypes.number,
						height: PropTypes.number,
						publicId: PropTypes.string,
						rawTransformation: PropTypes.string,
						version: PropTypes.number,
						width: PropTypes.number,
					}),
					fluid: PropTypes.shape({
						aspectRatio: PropTypes.number,
						sizes: PropTypes.string,
						src: PropTypes.string,
						srcSet: PropTypes.string,
					}),
					title: PropTypes.string,
				}).isRequired,
			}),
			details: PropTypes.arrayOf(
				PropTypes.shape({
					heading: PropTypes.string,
					content: PropTypes.object,
				})
			).isRequired,
			footer: PropTypes.shape({
				heading: PropTypes.string,
				content: PropTypes.object,
			}).isRequired,
		})
	).isRequired,
};

export default InfoPanel;
export { InfoPanel };
